import axiosProxy from '@/api/setting';
import store from '@/store/index';

import i18n from '@/lang/index';
import { getConfig } from '@/setting';
const { hostHttpProtocol, host } = getConfig();

export function login(data) {
	return axiosProxy({
		url: '/app/auth/login',
		method: 'post',
		data
	});
}

export function getRefreshToken({ refreshToken = store.getters.refreshToken, refreshTokenID = store.getters.refreshTokenID }) {
	return axiosProxy({
		LOADING: false,
		url: '/app/auth/token/refresh',
		method: 'post',
		data: {
			refreshToken,
			refreshTokenID,
		}
	});
}

export function getRefreshTokenAxios({ refreshToken = store.getters.refreshToken, refreshTokenID = store.getters.refreshTokenID }) {
	return axios({
		baseURL: `${hostHttpProtocol}://${host}/api/v1`,
		timeout: 60000,
		headers: {
			'Content-Type': 'application/json'
		},
		url: '/app/auth/token/refresh',
		method: 'post',
		data: {
			refreshToken,
			refreshTokenID,
		}
	});
}

export function logout() {
	const notifyToken = store.getters.notifyToken;

	if (!notifyToken) {
		MESSAGE("e", i18n.t("warn.notifyTokenIsEmpty"));
		return undefined;
	}

	return axiosProxy({
		url: '/app/auth/logout',
		method: 'post',
		data: {
			refreshToken: store.getters.refreshToken,
			fcmToken: store.getters.notifyToken
		}
	});
}

export function register(data) {
	return axiosProxy({
		url: '/app/users',
		method: 'post',
		data
	});
}

export function editPassword(data) {
	return axiosProxy({
		url: '/app/auth/password',
		method: 'post',
		data
	})
}
//寄送忘記密碼驗證信時使用
export function forgetPwdValue(data) {
	return axiosProxy({
		url: '/app/auth/resetPassword',
		method: 'post',
		data
	})
}
//寄送忘記密碼驗證信時使用
export function resetPassword(data) {
	return axiosProxy({
		url: '/app/auth/password/confirmToken',
		method: 'post',
		data
	})
}
//OTP註冊
export function otpRegister(data) {
	return axiosProxy({
		url: '/app/users/signup/otp',
		method: 'post',
		data
	});
}
export function otpRegisterVerify(data) {
	return axiosProxy({
		url: '/app/users/signup/otp/verify',
		method: 'post',
		data
	});
}
//OTP登入
export function sendOtp(email) {
	return axiosProxy({
		url: '/app/auth/signin/otp',
		method: 'post',
		data: {
			email: email
		}
	});
}
export function otpLogin(data) {
	return axiosProxy({
		url: '/app/auth/signin/otp/verify',
		method: 'post',
		data
	});
}